import { PARTNER_NAVIGATION } from '../constants/new-partner/partner-navigation';
import PartnerDetailsInformation from '../components/partners/PartnerDetailsInformation';
import { PartnerDetailsFees } from '../components/partners/PartnerDetailsFees';
import PartnerDetailsAddress from '../components/partners/PartnerDetailsAddress';
import PartnerDetailsContactInformation from '../components/partners/PartnerDetailsContactInformation';
import PartnerDetailsSupportInformation from '../components/partners/PartnerDetailsSupportInformation';
import PartnerDetailsNotification from '../components/partners/PartnerDetailsNotification';
import { PartnerDetailsBank } from '../components/partners/PartnerDetailsBank';
import { PartnerDetailsApiKeys } from '../components/partners/PartnerDetailsApiKeys';
import React from 'react';
import { PartnerDetailsApiKeyDetails } from '../components/partners/PartnerDetailsApiKeyDetails';
import { MERCHANTS_TABS } from '../utils/merchantUtils';
import { MerchantWebhooksListPage } from '../views/merchants/details/MerchantWebhooksListPage';
import { WebhookCreateComponent } from '../components/developers/webhooks_page/WebhookCreateComponent';

export const PARTNER_DETAILS_BASE_URL = '/partners/:partnerId';

export const partnerDetailsRoutes = [
  {
    key: PARTNER_NAVIGATION.PARTNER_INFO,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.PARTNER_INFO}`,
    component: <PartnerDetailsInformation />
  },
  {
    key: PARTNER_NAVIGATION.ADDRESS,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.ADDRESS}`,
    component: <PartnerDetailsAddress />
  },
  {
    key: PARTNER_NAVIGATION.CONTACT,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.CONTACT}`,
    component: <PartnerDetailsContactInformation />
  },
  {
    key: PARTNER_NAVIGATION.SUPPORT,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.SUPPORT}`,
    component: <PartnerDetailsSupportInformation />
  },
  {
    key: PARTNER_NAVIGATION.NOTIFICATIONS,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.NOTIFICATIONS}`,
    component: <PartnerDetailsNotification />
  },
  {
    key: PARTNER_NAVIGATION.BANK,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.BANK}`,
    component: <PartnerDetailsBank />
  },
  {
    key: PARTNER_NAVIGATION.FEES,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.FEES}`,
    component: <PartnerDetailsFees />
  },
  {
    key: PARTNER_NAVIGATION.WEBHOOKS,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.WEBHOOKS}`,
    component: <MerchantWebhooksListPage />,
  },
  {
    key: `${PARTNER_NAVIGATION.WEBHOOKS}-webhookId`,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.WEBHOOKS}/:webhookId`,
    component: <WebhookCreateComponent />,
  },
  {
    key: PARTNER_NAVIGATION.API_KEYS,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.API_KEYS}`,
    component: <PartnerDetailsApiKeys />
  },
  {
    key: `${PARTNER_NAVIGATION.API_KEYS}-id`,
    pathname: `${PARTNER_DETAILS_BASE_URL}/${PARTNER_NAVIGATION.API_KEYS}/:clientId`,
    component: <PartnerDetailsApiKeyDetails/>
  },
];
